
import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants'
import { Row, Col } from 'reactstrap';
export default class DeploymentMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            deploymentFlag: false
        }
    }
    render() {
        const { deploymentFlag } = this.state
        let marginVal = this.props.margin
        return (
            <>
                {
                    deploymentFlag ?
                        this.props.row ?
                            <Row style={this.props.margin ? { marginTop: marginVal } : null}>
                                <Col md="12">
                                    <p className="deployment-info">
                                    <span>There will be a schedule maintenance on SPARTA servers, on 5th April 2026 Sunday between 1:30AM - 2:30AM UTC, Please contact support@sparta.aero for more information.</span>
                                        <span >
                                            <img width="13" onClick={() => { this.setState({ deploymentFlag: false }) }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon"/>
                                        </span>
                                    </p>
                                </Col>
                            </Row>
                            :
                            <Grid item sm="12">
                                <p className="deployment-info">
                                <span>There will be a schedule maintenance on SPARTA servers, on 5th April 2026 Sunday between 1:30AM - 2:30AM UTC, Please contact support@sparta.aero for more information.</span>
                                    <span >
                                        <img width="13" onClick={() => { this.setState({ deploymentFlag: false }) }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon"/>
                                    </span>
                                </p>
                            </Grid>
                        :
                        null}
            </>
        )
    }
}